// 是否允许渲染
export const ALLOWPAINT = 'ALLOWPAINT';